import React, { useState } from "react";
import GenericModal from "../../../components/modal/GenericModal";
import { configurarSiteProcesoCierreAPI } from "../../../consumers/backendApisUrls";
import { useManagePostRequest } from "../../../hooks/useManagePostRequest/useManagePostRequest";

const ConfigurarSite = ({ toggleModal, idProcesoCierre, urlInicial, mostrarInicial, refreshTable }) => {
  const [managePost] = useManagePostRequest();

  const [urlSite, setUrlSite] = useState(urlInicial ?? "");
  const [mostrarSite, setMostrarSite] = useState(mostrarInicial === true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleOnSubmit = async () => {
    setIsSubmitting(true);
    try {
      const payload = { IdProcesoCierre: idProcesoCierre, UrlSite: urlSite, MostrarSite: mostrarSite };
      await managePost(configurarSiteProcesoCierreAPI(), payload, async () => {
        await refreshTable();
        toggleModal();
      });
    } catch (error) {
      console.error(error);
    }
    setIsSubmitting(false);
  };

  return (
    <GenericModal titulo={"Configurar Site"} showModal={toggleModal} width={"620px"}>
      <div className="modal-body pt-0 pl-0">
        <div className="container-fluid">
          <div className="form-group row">
            <label className="col-sm-4 col-form-label modal-label">Enlace del site</label>
            <div className="col-sm-8 black-color">
              <input
                className="form-control"
                type="url"
                maxLength={200}
                placeholder="https://"
                value={urlSite}
                onChange={(e) => setUrlSite(e.target.value)}
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-4 col-form-label modal-label">Mostrar site</label>
            <div className="col-sm-8 black-color">
              <div className="custom-control custom-switch pt-1" style={{ zIndex: 0 }}>
                <input
                  className="custom-control-input hand-pointer"
                  type="checkbox"
                  id="configurar-site-mostrar"
                  checked={mostrarSite}
                  onChange={(e) => setMostrarSite(e.target.checked)}
                />
                <label className="custom-control-label hand-pointer" htmlFor="configurar-site-mostrar">
                  {mostrarSite ? "Sí" : "No"}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-footer d-flex justify-content-end">
        <div className="button">
          <button className="btn btn-primary generic-button-ficha mr-2" type="button" disabled={isSubmitting} onClick={handleOnSubmit}>
            Guardar
          </button>
          <button className="btn btn-primary generic-button-ficha" type="button" onClick={toggleModal}>
            Cancelar
          </button>
        </div>
      </div>
    </GenericModal>
  );
};

export default ConfigurarSite;
